<template>
	<div id="enterprise_detail" v-title data-title="供给需求详情页">
		<headerbar :curindex="6"></headerbar>
		<div class="demanddetail ">
		 <p class="pageguide centerpage">
		 	<router-link to="/">首页</router-link>&gt; 
		 	<router-link to="/demandlist" target="_blank">技术{{demandtype}}</router-link>
		 	&gt;<span>{{baseinfor.title}}</span>
		 </p>
			<div class="demand_de_top whitebox centerpage"> 
				<div class="demand_de_title"><i class="flowicon icon"></i><h3 class="title">{{baseinfor.title}}</h3></div>
				<div class="demand_infor"  v-if="dstype == 'd'"> 
					<p class="companyinforN oh"> 
						<span class="fl"><i>所属行业：</i><em :title="baseinfor.industry">{{baseinfor.industry}}</em></span>  
						<span class="fl"><i>服务类型：</i><em>{{baseinfor.serviceType}}</em></span>  
						<span class="fl"><i>所属领域：</i><em>{{baseinfor.notion}}</em></span>  
						<span class="fl"><i>发布方：</i><em>{{baseinfor.publisher}}</em></span>  
					</p>
					<p class="companyinforN oh companyinfor5"> 
						<span class="fl"><i>所  在  地：</i><em>{{baseinfor.area}}</em></span>  
						<span class="fl"><i>预      算 :</i><em>{{baseinfor.budget}}</em></span>  
						<span class="fl"><i>截止日期:</i><em>{{baseinfor.endDate}}</em></span>  
					</p>  
				</div>
					<div class="demand_infor"  v-if="dstype == 's'">
						<p class="companyinforN oh"> 
							<span class="fl"><i>所属行业：</i><em :title="baseinfor.industry">{{baseinfor.industry}}</em></span>  
							<span class="fl"><i>技术类型：</i><em>{{baseinfor.techType}}</em></span>  
							<span class="fl"><i>所属领域：</i><em>{{baseinfor.notion}}</em></span>  
							<span class="fl"><i>发布方：</i><em>{{baseinfor.publisher}}</em></span>  
						</p>
						<p class="companyinforN oh companyinfor5"> 
							<span class="fl"><i>成  熟  度：</i><em>{{baseinfor.maturity}}</em></span>  
							<span class="fl"><i>主题分类 :</i><em>{{baseinfor.topicType}}</em></span>  
							<span class="fl"><i>发布日期:</i><em>{{baseinfor.createTime}}</em></span>  
						</p>  
					</div>  
			</div>
			<div class="demand_de_top whitebox centerpage"> 
				<div class="demand_de_title"><i class="bookicon icon"></i><h3 class="title">技术{{dstype == 'd' ?"需求":"成果"}}简介</h3></div>
				<div class="demand_content" v-html="baseinfor.summary"> 
				<!-- <h5>成果简介：</h5>
				<p>随着我国“5G 技术”和“新基建”的快速发展，要求变压器向小型化和高效化发展。提高变压的工作频率是电源小型化和高效化的最有效解决方案，因为变压器中磁芯的体积和重量与工作频率（f）的平方根成反比。虽然 f 的提高有利于变压器的小型化和高效化，但也会显著的增加磁芯的损耗。铁基纳米晶软磁合金由于具有低的矫顽力、高的磁导率和高的电阻率被认为是最具有竞争力的的绿色环保软磁材料。</p>
				<p>目前工业化生产的 Fe73.5Si13.5B9Cu1Nb3（FINEMET）纳米晶合金的 Bs 只有1.24T，限制了铁芯最大工作磁通密度（Bmax）的进一步提高，不利于电子元器件体积的进一步减小，因此提高铁基纳米晶软磁合金的 Bs 成为了科研工作者长期追求的目标。虽然目前针对提高纳米晶合金的 Bs 开展了大量的工作。但它们存在这几方的问题：</p>
				<p>（1）非晶形成能力低；</br>（2）升温速率要求高，约 300-400K/min；</br>（3）退火时间窗口短，约 5-10min。严重限制了其工业化应用。</p>
				<p>本团队开发的新型 Fe-B-P-C-Cu 系纳米晶软磁合金，通过提高 α-Fe 相在晶化过程中的形核速率，利用 α-Fe 相形核和长大之间的相互竞争关系，降低了软磁性能对升温速率的敏感性；通过调整 Cu3P 元素团簇的析出速率和长大速率，成功开发了退火时间长达 60min，升温速率低至 20K/m 的 FeBPCCu 合金。其在693K-723K 退火时的最佳退火时间可以延长到 60min，特别是在 723K 退火 30min后合金具有最佳的综合软磁性能，Hc 为 7.0A/m，Bs 为 1.80T，μe 为 17000。</p>
				<h5>成熟程度及推广应用情况:</h5>
				<p>目前处于何种研发阶段：☐研发 ☐小试 ☒中试 ☐小批量生产 ☐产业化；</p>
				<p>样机：☐有 ☒无</p>
				<p>已投入成本：300 万元。</p>
				<p>推广应用情况：目前已与洛阳中赫新材料电器设备有限公司开展了小规模的试产。</p>
				<p>期望技术转移成交价格（大概金额）：500 万。</p>
				<h5>技术优势：</h5>
				<p>相对于目前已报到的高 Bs 铁基纳米晶软磁合金而言，我们开发的 Fe-B-P-CCu-Cr-N 合金系具有以下几方面的技术优势：</p>
				<p>（1）高的非晶形成能力；</br>（2）宽的最佳退火温度区间 60K；</br>（3）长的最佳退火时间 60min；</br>（4）低的升温速率要求20K/min；</br>（5）低的生产成本。</p>
				<h5>性能指标：</h5>
				<p>饱和磁化强度 Bs=1.80T，矫顽力 Hc=8.0A/m，磁导率 μe=17000，退火窗口：退火时长可到 60min，升温速率低至 20K/min，退火温度区间可达 60K。</p>
				<h5>市场分析：</h5>
				<p>可转移的重点行业包括：电力变压器系统，电机系统，无线充电系统，家电行业等；重点公司：洛阳中赫新材料电器设备有限公司，安泰科技股份有限公司，青岛云路新能源科仪有限公司；重点区域：中国。</p>
				<h5>经济效益分析：</h5>
				<p>相对于目前工业应用的 Fe73.5Si13.5B9Cu1Nb3（FINEMET），本项目的 Fe-B-P-C-Cu 合金因不含 Nb 元素，原材料成本可降低 40%以上。本项目开发的材料可应用的产品市场规模在数亿元以上。</p>
				<h5>成果亮点：</h5>
				<p>1. 具有自主知识产权，研究成果已授权发明专利 2 项，申请 5 项。</p>
				<p>2. 成果来源：自然基金项目“基因性团簇变异增韧铁基非晶纳米晶合金的理论与方法”、国家重点研发计划项目“特种软磁合金设计及工程化集成技术开发”、企业横向项目“新型铁基非晶纳米晶软磁合金研制、开发和应用”等。</p>
				<p>3. 技术先进性：国际先进，成功解决了目前高 Bs 铁基纳米晶软磁合金对退火升温速率和保温时间高敏感性的问题，满足了目前工业化生产的需求。</p> -->
				</div> 
			</div>
		</div>
		<footerbar></footerbar>
	</div>
</template>

<script>
	export default {
		name: 'demandDetail',
		data() {
			return { 
				userdata:{},
				demandtype:"需求",
				dstype:"d",
				//baseinfo里的type 1 表示需求 2表示供给 只有一些基础信息不一样
				baseinfor:{title:'光储充一体化系统（整合的方案）',type:2}
			}
		}, 
		beforeCreate() { },
		created() {
			// window.scrollTo(0,0); 
			this.getuserinfor(); 
		},
		mounted() {
			window.scrollTo(0, 0);   
		},
		methods: {
			getuserinfor(){
				// this.bus.$emit('loading',true);
				let dataddd=sessionStorage.getItem('userData') ? sessionStorage.getItem('userData'):localStorage.getItem('userData') ;
				if(typeof(dataddd) == 'object'){
				this.userdata = dataddd;
				}else{
				this.userdata = JSON.parse(dataddd);
				}; 
			if(this.userdata.userType == 5){
					this.demandtype="供给";
				}else if(this.userdata.userType == 2 || this.userdata.userType == 3){
					this.demandtype="需求";
				} 
				this.dstype = this.$route.query.type;
				this.demandid=this.$route.query.id;  
				this.getdetailinfor(this.dstype,this.demandid); 
			}, 
			getdetailinfor(type,id){
				var ajaxurl="",_this=this;
				if(type == 'd'){
					ajaxurl=this.$api.cyl.techdemand.detail()+"?id="+id;
				}else if(type  == "s"){
					ajaxurl=this.$api.cyl.techsupply.detail()+"?id="+id;
				}
				this.$axios.get(ajaxurl,{headers:{AuthToken:this.userdata.token}}).then(function(res){
					if(!res.data.success){
						_this.tokenfailed('logout');
						return;
					}
				 _this.baseinfor=res.data.data;
					document.title = _this.baseinfor.title;
				 }) 
				console.log(ajaxurl);
				
				
			}
		}
	}
</script>

<style>
</style>
